module.exports = __webpack_public_path__ + "img/bg-refer3.19a98c03.png";